<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>

<div class="row mb-3" *ngIf="loaded">

  <div class="col text-right align-self-center">
    <button class="btn btn-default mr-2" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>

<div class="card" *ngIf="loaded">
  <div class="card-header lead font-weight-bold">
    Stream Keyword Detail
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <small><i class="text-danger">* indicates mandatory field</i></small>
      </div>
      <div class="col-12 row">
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> ShortCode:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.shortCode" class="form-control" placeholder="ShortCode" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Keyword:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.keyword" class="form-control" placeholder="Keyword" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Operator:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.operator" class="form-control" placeholder="Operator" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Country :</dt>
        <dd class="col-4">
          <select class="form-control" placeholder="Select" [(ngModel)]="keyword.country">
            <option *ngFor="let country of countryList" [value]="country.code">{{country.name}}</option>
          </select>
        </dd>

        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Min :</dt>
        <dd class="col-4">
          <input type="number" [(ngModel)]="keyword.min" class="form-control" placeholder="Min" min="0" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Max :</dt>
        <dd class="col-4">
          <input type="number" [(ngModel)]="keyword.max" class="form-control" placeholder="Max" min="0" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Rate :</dt>
        <dd class="col-4">
          <input type="number" [(ngModel)]="keyword.rate" class="form-control" placeholder="Rate" min="0" max="100" />
        </dd>
        <dt class="col-2 text-right align-self-center">Full URL :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.url" class="form-control" placeholder="URL" />
        </dd>
        <dt class="col-2 text-right align-self-center">Customized URL :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.customizedUrl" class="form-control" placeholder="Customized URL" />
        </dd>
        <dt class="col-2 text-right align-self-center">Replacement Pairs :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="keyword.replacementPairs" class="form-control" placeholder='{"param1":"strVal","param2":1}' />
        </dd>
      </div>
      <div class="col-12">
        <ol type="A">
          <li><span class="font-weight-bold text-danger font-italic">Max:</span> there is no limitation when it's equal to 0; it will not post-back to client when it's little than 0</li>
          <li><span class="font-weight-bold text-danger font-italic">Rate:</span>It will not post-back to client when it's little than equal 0</li>
          <li><span class="font-weight-bold text-danger font-italic">Customized URL:</span>The priority of Customized-URL is greater than Full-URL</li>
        </ol>
      </div>
    </div>
  </div>
</div>
